<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate/>
    </div>

    <div v-else>
      <v-layout row>
        <v-flex>
          <h1>{{ $tc('COMMON.FAVORITE', 2) }}</h1>
        </v-flex>
      </v-layout>

      <masonry :cols="{default: 3, 1200: 2, 960: 1}" :gutter="40">
        <tk-artwork
          class="mb-4"
          v-for="artwork in artworks"
          :key="artwork.id"
          :artwork="artwork"
          @remove="onRemove"
          removeBtn="true"
        />
      </masonry>

      <div class="text-xs-right mt-4" v-if="artworks.length">
        <v-pagination
          @input="fetchData"
          @click.native="scrollTop"
          :disabled="loading"
          :value="pagination.currentPage"
          :length="pagination.lastPage"
          :total-visible="7"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";
import VueScrollTo from "vue-scrollto";

const artworksRepo = RepositoryFactory.artworks();
const handler = new ErrorHandler();
// TODO refactor, pages favorites and subscription have similar logic

export default {
  data() {
    return {
      artworks: [],
      pagination: {},
      loading: true
    };
  },

  created() {
    this.fetchData(1);
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await artworksRepo.profileFavorites(page);
        this.artworks = res.data;
        this.pagination = res.pagination;
      });
      this.loading = false;
    },

    async onRemove(artwork) {
      console.log("onRemove", artwork);
      if (!artwork.favorite_id) return;
      const pos = this.artworks.findIndex(art => art.id === artwork.id);
      if (pos !== -1) {
        this.artworks.splice(pos, 1);
        await this.$auth.removeFavorite(artwork.favorite_id);
        await this.$auth.refresh();
      }
    },

      scrollTop() {
          VueScrollTo.scrollTo({offset: 0});
      }
  }
};
</script>
